import { app } from '../../../../../app';
import { Controller } from './directory-manage-domains.controller';

app.component('companyDirectoryIntegrationManageDomains', {
    bindings: {domains: '<'},
    controller: Controller,
    templateUrl: require('./directory-manage-domains.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/directory-manage-domains.component.js